import React, {FC} from 'react';
import styled from 'styled-components';

import {getDirectionStyles} from '../../../../../../utils/ThemeUtils';

const StyledLegendContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    margin: ${p => p.theme.muiTheme.spacing(0.4, 0)};

    & > span: {
        line-height: 1;
    }
`;

const StyledLegendMarker = styled.div`
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 3px solid;

    margin: ${p =>
        getDirectionStyles(p.theme.muiTheme.direction)(
            p.theme.muiTheme.spacing(0, 2, 0, 0),
            p.theme.muiTheme.spacing(0, 0, 0, 2)
        )};
`;

const StyledSpan = styled.span`
    font-size: 18px;
    margin: ${p =>
        getDirectionStyles(p.theme.muiTheme.direction)(
            p.theme.muiTheme.spacing(0, 1, 0, 0),
            p.theme.muiTheme.spacing(0, 0, 0, 1)
        )};
`;

export interface PlayrateTooltipLegendParams {
    color: string;
    value: string;
}

const PlayrateTooltipLegend: FC<PlayrateTooltipLegendParams> = ({
    color,
    value
}: PlayrateTooltipLegendParams) => (
    <StyledLegendContainer>
        <StyledLegendMarker style={{color}} />
        <StyledSpan>{value}</StyledSpan>
    </StyledLegendContainer>
);

export default PlayrateTooltipLegend;
